<template>
  <v-card>
    <v-toolbar card dense>
      <div class="text-capitalize beez-bold">Tulip Inbound Emails</div>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <v-btn slot="activator" flat icon @click="refresh()">
          <v-icon>cached</v-icon>
        </v-btn>
        <span>Refresh</span>
      </v-tooltip>
    </v-toolbar>
    <v-card-title>
      <v-tooltip bottom>
        <v-btn slot="activator" flat icon @click="search = ''">
          <v-icon>clear</v-icon>
        </v-btn>
        <span>Clear search</span>
      </v-tooltip>
      <v-text-field
        v-model="search"
        color="secondary"
        append-icon="search"
        label="Search"
        single-line
        hide-details
      />
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="emails"
      :search="search"
      :loading="emailLoading"
      item-key="id"
      :pagination.sync="pagination"
    >
      <v-progress-linear
        slot="progress"
        color="accent"
        indeterminate
      ></v-progress-linear>
      <template slot="items" slot-scope="props">
        <tr>
          <td
            @click="
              props.expanded = !props.expanded
              resetItem(props.item)
            "
            class="text-xs-left"
          >
            {{ props.item.from[0].personal + ' ' + props.item.from[0].address }}
          </td>
          <td
            @click="
              props.expanded = !props.expanded
              resetItem(props.item)
            "
            class="text-xs-left"
          >
            <div class="body-1 font-weight-bold">
              {{ props.item.subject }}
            </div>
          </td>
          <td
            @click="
              props.expanded = !props.expanded
              resetItem(props.item)
            "
            class="text-xs-left"
          >
            <div class="body-1 font-weight-bold">
              {{ props.item.receivedAtLocal }}
            </div>
          </td>

          <!--          <td class="align-center justify-center fill-height">-->
          <!--            <v-btn flat icon>-->
          <!--              <v-icon medium @click="">-->
          <!--                done-->
          <!--              </v-icon>-->
          <!--            </v-btn>-->
          <!--          </td>-->
        </tr>
      </template>
      <template slot="expand" slot-scope="props">
        <div class="pa-2" style="border-radius: 5px">
          <v-card hover>
            <v-toolbar dense flat class="beez-bold">
              Inbound Email options
              <v-spacer></v-spacer>
              <v-tooltip bottom>
                <v-btn
                  flat
                  icon
                  slot="activator"
                  @click="resetItem(props.item)"
                >
                  <v-icon>refresh</v-icon>
                </v-btn>
                <span>Reset</span>
              </v-tooltip>
              <v-tooltip bottom>
                <v-btn flat icon slot="activator">
                  <v-icon>translate</v-icon>
                </v-btn>
                <span>Translate</span>
              </v-tooltip>
              <v-tooltip bottom>
                <v-btn flat icon slot="activator" @click="setItem(props.item)">
                  <v-icon>clear</v-icon>
                </v-btn>
                <span>Clear Highlights</span>
              </v-tooltip>
              <v-tooltip bottom>
                <v-btn
                  flat
                  icon
                  slot="activator"
                  @click="highlight(props.item)"
                  :disabled="nectarEntityMap.length === 0"
                  :loading="highlightLoader"
                >
                  <v-icon>offline_bolt</v-icon>
                </v-btn>
                <span>Highlight Entities in Email</span>
              </v-tooltip>
              <v-tooltip bottom>
                <v-btn
                  flat
                  icon
                  slot="activator"
                  @click="analyze(props.item)"
                  :loading="analyzeLoader"
                >
                  <v-icon>memory</v-icon>
                </v-btn>
                <span>Identify Entities (NLP Analysis)</span>
              </v-tooltip>
              <v-tooltip bottom>
                <v-btn flat icon slot="activator">
                  <v-icon>drafts</v-icon>
                </v-btn>
                <span>Mark as Read</span>
              </v-tooltip>
            </v-toolbar>
            <v-slide-y-reverse-transition>
              <v-card
                class="ml-3 mr-3 mb-3 pb-2"
                style="border-bottom-left-radius: 10px; border-bottom-right-radius: 10px"
                v-if="identifiedEntities.length > 0"
              >
                <v-card-title class="beez-bold"
                  >Identified Entities
                </v-card-title>
                <template v-for="(item, i) in identifiedEntities">
                  <v-chip :key="i + 'chip'" v-model="item.enabled" close>
                    <v-avatar
                      :color="item.color"
                      :key="i + 'chip-avatar'"
                      @click="showPickerDialog(item)"
                    ></v-avatar>
                    <span :key="i + 'chip-span'" class="text-uppercase">{{
                      item.entity
                    }}</span>
                  </v-chip>
                </template>
              </v-card>
            </v-slide-y-reverse-transition>
            <v-fade-transition>
              <v-dialog v-model="showPicker" hide-overlay width="200">
                <v-layout
                  align-center
                  justify-center
                  row
                  fill-height
                  v-if="showPicker"
                >
                  <chrome-picker
                    :value="selectedEntity.color"
                    @input="updateColor"
                  ></chrome-picker>
                </v-layout>
              </v-dialog>
            </v-fade-transition>
            <v-card-text>
              <div
                style="text-align: left"
                v-html="selectedItem.mailContent"
              ></div>
            </v-card-text>
          </v-card>
        </div>
      </template>
      <template slot="no-data">
        <v-alert :value="true" color="success" icon="info">
          No Emails found!
        </v-alert>
      </template>
      <template slot="no-results">
        <v-alert :value="true" color="error" icon="warning">
          Your search for "{{ search }}" found no results.
        </v-alert>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'
import { Chrome } from 'vue-color'
import u from '@/utils'

export default {
  name: 'InboundEmails',
  components: {
    'chrome-picker': Chrome
  },
  data() {
    return {
      pagination: {
        sortBy: 'receivedAt',
        descending: true
      },
      search: '',
      selectedItem: null,
      selectedEntity: null,
      highlightLoader: false,
      analyzeLoader: false,
      expanded: false,
      showPicker: false,
      nectarEntityMap: [],
      tagMaps: [],
      identifiedEntities: [],
      highlightPart1: '<mark style="background:',
      highlightPart2:
        '; padding: 0.45em 0.6em; margin: 0.4em; line-height: 2.3em; border-radius: 0.35em; box-decoration-break: clone; -webkit-box-decoration-break: clone">\n',
      highlightPart3:
        '    <span style="background:white; padding: .2em .3em; font-size: 0.8em; font-weight: bold; line-height: 1; border-radius: 0.35em; text-transform: uppercase; vertical-align: middle; margin-left: 0.5rem">',
      highlightPart4: '</span></mark>',
      headers: [
        {
          text: 'From',
          align: 'left',
          value: 'from'
        },
        { text: 'Subject', value: 'subject' },
        { text: 'Received At', value: 'receivedAtLocal' }
        // { text: 'Action', value: '' }
      ]
    }
  },
  mounted() {
    this.$store.dispatch('fetchEmails')
  },
  methods: {
    refresh() {
      this.$store.dispatch('fetchEmails')
    },
    setItem(item) {
      this.selectedItem = u.clone(item)
      this.highlightLoader = false
    },
    resetItem(item) {
      this.setItem(item)
      this.reset()
    },
    showPickerDialog(item) {
      this.selectedEntity = item
      this.showPicker = true
    },
    updateColor(value) {
      let _self = this
      let identifiedEntity = this.identifiedEntities.find(
        i => i.entity === _self.selectedEntity.entity
      )
      if (identifiedEntity) {
        identifiedEntity.color = value.hex
        this.selectedEntity.color = value.hex
      }
    },
    reset() {
      this.identifiedEntities = []
      this.nectarEntityMap = []
    },
    getHighlight(text, entity, colorCode) {
      return (
        this.highlightPart1 +
        colorCode +
        this.highlightPart2 +
        text +
        this.highlightPart3 +
        entity +
        this.highlightPart4
      )
    },
    getRandomLightColor() {
      var letters = 'ABCDE'.split('')
      var color = '#'
      for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * letters.length)]
      }
      return color
    },
    extractContent(html) {
      return new DOMParser().parseFromString(html, 'text/html').documentElement
        .textContent
    },
    async analyze(emailItem) {
      this.analyzeLoader = true
      this.resetItem(emailItem)
      let regex = '(<style>([^>]+)><\\/style>)'
      let replaceString = new RegExp(regex, 'igm')
      let cleansedContent = emailItem.mailContent.replace(replaceString, '')
      try {
        let response = await this.$store.dispatch(
          'getNLP',
          this.extractContent(cleansedContent)
        )
        this.nectarEntityMap = response.data
        let _self = this
        this.nectarEntityMap.forEach(item => {
          let identifiedItem = {}
          let identifiedEntity = _self.identifiedEntities.find(
            i => i.entity === item.entity
          )
          if (!identifiedEntity) {
            identifiedItem.entity = item.entity
            identifiedItem.color = this.getRandomLightColor()
            identifiedItem.enabled = true
            _self.identifiedEntities.push(identifiedItem)
          }
        })
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          message: 'Nectar request failed!',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          type: 'error',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }

      this.analyzeLoader = false
    },
    highlight(emailItem) {
      this.setItem(emailItem)
      this.highlightLoader = true

      let _self = this
      let emailTagRegex = '<[^>]*>'
      let replaceString = new RegExp(emailTagRegex, 'igm')
      let htmlTags = this.selectedItem.mailContent.match(replaceString)

      let highlightedBody = this.selectedItem.mailContent

      htmlTags.forEach(item => {
        let uniqueId =
          '<' +
          Math.random()
            .toString(36)
            .substring(2) +
          Date.now().toString(36) +
          '>'
        this.tagMaps.push({ id: uniqueId, value: item })
        highlightedBody = highlightedBody.replace(item, uniqueId)
      })

      this.nectarEntityMap.forEach(item => {
        let identifiedEntity = _self.identifiedEntities.find(
          i => i.entity === item.entity
        )
        if (identifiedEntity) {
          this.selectedEntity = identifiedEntity
          if (identifiedEntity.enabled) {
            let uniqueId =
              '<' +
              Math.random()
                .toString(36)
                .substring(2) +
              Date.now().toString(36) +
              '>'
            this.tagMaps.push({
              id: uniqueId,
              value: _self.getHighlight(
                item.text,
                identifiedEntity.entity,
                identifiedEntity.color
              )
            })
            let regExText = ''
            if (!isNaN(item.text)) {
              regExText = '\\b' + item.text + '\\b'
              let itemRegex = new RegExp(regExText, 'igm')
              highlightedBody = highlightedBody.replace(itemRegex, uniqueId)
            } else {
              regExText = item.text
              let index = 0
              do {
                highlightedBody = highlightedBody.replace(regExText, uniqueId)
              } while (
                (index = highlightedBody.indexOf(regExText, index + 1)) > -1
              )
            }
          }
        }
      })

      this.tagMaps.forEach(item => {
        let index = 0
        do {
          highlightedBody = highlightedBody.replace(item.id, item.value)
        } while ((index = highlightedBody.indexOf(item.id, index + 1)) > -1)
      })

      this.selectedItem.mailContent = highlightedBody

      this.highlightLoader = false
    }
  },
  computed: {
    ...mapState({
      emails: state => state.emails.emailList,
      emailLoading: state => state.emails.emailLoading
    })
  }
}
</script>

<style scoped>
.htmlContent {
  font-family: Arial, Helvetica Neue, Helvetica, sans-serif;
}
</style>
